module.exports = __webpack_public_path__ + "img/magician-trick.4d174643.png";